module.exports = __webpack_public_path__ + "ab83b82944d8935a8e5018bea7b31a7e.svg";